import { render } from "./Kalendar.vue?vue&type=template&id=294675cd"
import script from "./Kalendar.vue?vue&type=script&lang=js"
export * from "./Kalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__